// extracted by mini-css-extract-plugin
export default {"text":"PkoNwqZjhLYK9VpYu4v2","name":"bMWxONmY3idZ20uv4UuU","count":"zAZhYfgZxLL5XUWkb6nZ"};